import axios from "axios";

const SERVER_URL = 'https://funeraria-forms-production.up.railway.app';
//const SERVER_URL = 'http://localhost:4000';

export const login = (user) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/login`,
        data: user
    };

    return axios.request(options);
}

export const getRequests = () => {
    const options = {
        method: 'GET',
        url: `${SERVER_URL}/requests`
    };

    return axios.request(options);
}

export const getContracts = () => {
    const options = {
        method: 'GET',
        url: `${SERVER_URL}/contracts`
    };

    return axios.request(options);
}

export const insertContract = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/insertContract`,
        data: data
    };
    return axios.request(options);
}

export const insertRequest = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/insertRequest`,
        data: data
    };
    return axios.request(options);
}

export const updateContract = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/updateContract`,
        data: data
    };
    return axios.request(options);
}

export const updateRequest = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/updateRequest`,
        data: data
    };
    return axios.request(options);
}

export const getRequest = (id) => {
    const options = {
        method: 'GET',
        url: `${SERVER_URL}/getRequest/${id}`
    };
    return axios.request(options);
}

export const getContract = (id) => {
    const options = {
        method: 'GET',
        url: `${SERVER_URL}/getContract/${id}`
    };
    return axios.request(options);
}

export const updateUser = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/updateUser`,
        data: data
    };
    return axios.request(options);
}

export const deleteUser = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/deleteUser`,
        data: data
    };
    return axios.request(options);
}

export const getUsers = () => {
    const options = {
        method: 'GET',
        url: `${SERVER_URL}/users`
    };
    return axios.request(options);
}

export const deleteContract = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/deleteContract`,
        data: data
    };
    return axios.request(options);
}

export const deleteRequest = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/deleteRequest`,
        data: data
    };
    return axios.request(options);
}

export const register = (data) => {
    const options = {
        method: 'POST',
        url: `${SERVER_URL}/register`,
        data: data
    };
    return axios.request(options);
}
